const fieldDefinitions = {
  url: {
    key: 'url',
    labelKey: 'setting.list.webhook.url',
    header: 'licensePlate',
    isRedirectable: true,
    isResponsive: false,
  },
  total_vehicle: {
    key: 'total_vehicle',
    labelKey: 'setting.list.webhook.totalFleet',
    header: 'totalFleet',
  },
  general: {
    key: 'general',
    labelKey: 'setting.list.webhook.general',
    header: 'general',
  },
  dms: {
    key: 'dms',
    labelKey: 'setting.list.webhook.dms',
    header: 'dms',
  },
  driverBehavior: {
    key: 'driverBehavior',
    labelKey: 'setting.list.webhook.driverBehavior',
    header: 'driverBehavior',
  },
  adas: {
    key: 'adas',
    labelKey: 'setting.list.webhook.adas',
    header: 'adas',
  },
  dataUpdate: {
    key: 'dataUpdate',
    labelKey: 'setting.list.webhook.dataUpdate',
    header: 'dataUpdate',
  },
}

const getFields = (instance) => {
  return Object.values(fieldDefinitions).map((field) => ({
    ...field,
    label: instance.$t(field.labelKey),
    filter: true,
    width: 20,
  }))
}

export default getFields
